import React from "react";

import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
import DropdownSelect from "../../dropdown/Dropdown";
import TextInput from "../../UIComponent/TextInput";
import MultiSelectDropdown from "../../dropdown/MultiSelectDropdown";
import Option from "../../dropdown/multiSelectDropdownOption/MultiSelectOption";

function MembershipAdditionalInformation(props) {
  return (
    <div className="w-full">
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Business Presence / Market Interest
                </h2>
                <div className="flex items-center">
                  <div className="w-full outline-none appearance-none">
                    <DropdownSelect
                      drpIdentity={"BusinessInterest"}
                      optionArray={props.businessInterest}
                      setFilterParameters={props.setFilterParameters}
                      value={
                        props.membershipAdditionalInformation.businessPresenceId
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <Validation error={props.validState.error.email} /> */}
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Company present in other countries
                </h2>
                <div className="flex items-center">
                  <div className="w-full outline-none appearance-none">
                    <MultiSelectDropdown
                      options={props.countries}
                      isMulti
                      drpIdentity="MultiCountries"
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option,
                      }}
                      onChange={props.handleChangeMultiDropdownForCountry}
                      allowSelectAll={true}
                      value={props.membershipAdditionalInformation.countries}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <Validation error={props.validState.error.email} /> */}
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Market interest of your company{" "}
                </h2>
                <div className="flex items-center">
                  <div className="w-full outline-none appearance-none">
                    <DropdownSelect
                      drpIdentity={"MarketInterest"}
                      optionArray={props.marketInterest}
                      setFilterParameters={props.setFilterParameters}
                      value={
                        props.membershipAdditionalInformation.marketInterestId
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <Validation error={props.validState.error.email} /> */}
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  LinkedIn{" "}
                </h2>
                <TextInput
                  placeholder=""
                  type="text"
                  name="linkedIn"
                  maxLength={20}
                  value={props.membershipAdditionalInformation.linkedIn}
                  handleChange={props.handleChange}
                  identity="MembershipAdditionalInformation"
                />
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Facebook{" "}
                </h2>
                <TextInput
                  placeholder=""
                  type="text"
                  name="facebook"
                  maxLength={20}
                  value={props.membershipAdditionalInformation.facebook}
                  handleChange={props.handleChange}
                  identity="MembershipAdditionalInformation"
                />
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Instagram{" "}
                </h2>
                <TextInput
                  placeholder=""
                  type="text"
                  name="instagram"
                  identity="MembershipAdditionalInformation"
                  maxLength={20}
                  value={props.membershipAdditionalInformation.instagram}
                  handleChange={props.handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Save Button */}
      <div className="grid grid-cols-12 gap-6 pb-10">
        <div className="xl:col-span-12 lg:col-span-12 col-span-12 px-10">
          <a
            className="flex items-center justify-end"
            //href="/CreateCorporateMembers"
          >
            {props && props.isAddEditAdditionalInfoLoading === true ? (
              <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none" />
            ) : (
              <button
                className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                onClick={() => props.onSave()}
              >
                Save
              </button>
            )}
          </a>
        </div>
      </div>
    </div>
  );
}

export default MembershipAdditionalInformation;
